var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 9,
    viewBox: "0 0 1170 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1156,
    height: 3,
    transform: "matrix(-1 0 0 1 1163 3)",
    fill: "#003A75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C6.98528 0 9 2.01472 9 4.5C9 6.98528 6.98528 9 4.5 9C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0ZM4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3Z",
    fill: "#003A75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.5 0C1167.99 0 1170 2.01472 1170 4.5C1170 6.98528 1167.99 9 1165.5 9C1163.01 9 1161 6.98528 1161 4.5C1161 2.01472 1163.01 0 1165.5 0ZM1165.5 3C1164.67 3 1164 3.67157 1164 4.5C1164 5.32843 1164.67 6 1165.5 6C1166.33 6 1167 5.32843 1167 4.5C1167 3.67157 1166.33 3 1165.5 3Z",
    fill: "#003A75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineTechnology);
export default __webpack_public_path__ + "static/media/line_technology.425629e453255c59590ae3593a559dc3.svg";
export { ForwardRef as ReactComponent };